import React from 'react';
import { AttributesT } from '../../../utils/constants';
import s from './JeepType.module.scss';
import productStyle from './../Product.module.scss';
import { SimpleItem } from '../../SimpleItem/SimpleItem';
import { useAttribute } from '@threekit-tools/treble/dist';
import { getProductParameters } from '../Product';

export const JeepType = ({ ...props }: any) => {
  const name: AttributesT = props.name;
  const [attribute, setAttribute]: any = useAttribute(name);

  return (
    <div className={productStyle.product__wrapper}>
      {attribute.values.map((item: any, index: number) => {
        const data = getProductParameters({
          item,
          attribute,
          setAttribute,
          hintPosition: 'bottom',
          name,
        });

        return <SimpleItem {...data} key={`${item.value}-${index}`} />;
      })}
    </div>
  );
};
